import ComponentLabel from '../model/ComponentLabel';
import ComponentView from './ComponentView';

export default class ComponentLabelView extends ComponentView<ComponentLabel> {}
